import { TabTag } from "@/components/shared"
import { Image } from "@/components/ui"
import { ETransactionStatus } from "@/features/earns/components/progress-jobs/transaction.constants"
import { EFolderAssets, ETransactionType } from "@/modules/helpers/enum"
import { useShowSubmission } from "@/modules/helpers/hooks/shared/use-show-submission"
import { cn } from "@/modules/helpers/hooks/shared/utils"
import { getImageByNameFromS3 } from "@/modules/helpers/utils"
import type { SubmissionCampaign } from "@/modules/types"

type JobItemProps = {
  item: SubmissionCampaign
}

export function JobItem({ item }: JobItemProps) {
  const { setId } = useShowSubmission()
  const isPaidCampaign =
    item?.transactions &&
    item.transactions.type === ETransactionType.PAY_CAMPAIGN &&
    item.transactions.status === ETransactionStatus.COMPLETED
  return (
    <div
      onClick={() => setId(item?.id || "", item?.conversationCode)}
      className="bg-white border-b border-gray-300 p-3 mt-2 flex items-center gap-3 cursor-pointer"
    >
      {/* Image */}
      <div>
        <Image
          src={
            item?.affCampaigns?.thumbnailName?.includes("https")
              ? item?.affCampaigns?.thumbnailName
              : getImageByNameFromS3(
                  item?.affCampaigns?.thumbnailName,
                  item?.affCampaigns?.createdBy,
                  EFolderAssets.THUMBNAIL_AFFILIATE_CAMPAIGN
                )
          }
          alt=""
          className="w-[60px] h-[60px] object-cover overflow-hidden rounded-lg"
        />
      </div>

      {/* Middle content */}
      <div className="flex-1 flex flex-col gap-1">
        <p className="text-sm font-medium line-clamp-2">{item?.affCampaigns?.title}</p>

        <p className="text-xss text-primary">{item?.affCampaigns?.shopName}</p>
        {/* <p className="text-xss text-primary">
          Kết thúc: {dayjs(item?.workingAt).add(14, "day").format("DD/MM/YYYY")}
        </p> */}
      </div>
      <div className="flex flex-col gap-1 items-end">
        {isPaidCampaign && (
          <TabTag
            label="Đã nghiệm thu"
            className="bg-teal-50"
            textClassName="text-teal-700"
            isCapitalize={false}
          />
        )}

        {!isPaidCampaign && (
          <TabTag
            className="!bg-[#FFFBE0]"
            textClassName="!text-[#E5B800]"
            label="Chưa nghiệm thu"
            isCapitalize={false}
          />
        )}

        <p
          className={cn("text-base font-semibold", {
            "text-gradient-primary": isPaidCampaign,
            "text-[#E5B800]": !isPaidCampaign
          })}
        >
          {isPaidCampaign ? "+" : ""}
          <span>{Number(item?.affCampaigns?.cashAmount)?.toLocaleString()}</span> ₫
        </p>
        <p className="text-xs text-primary-800">Chi tiết</p>
      </div>
    </div>
  )
}
